<!--
 * @Author: 王佳宾
 * @Date: 2022-09-06 16:47:38
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-12-23 16:59:57
 * @Description:
 * @FilePath: \web\src\components\ProjectLibrary\main\orenodeSearch\keySearch\mineralType.vue
-->
<template>
  <section class="mineral-type-com" v-show="visible">
    <a-checkbox-group v-model:value="selectValue">
      <a-checkbox :value="item.name" v-for="item in list" :key="item.name"><span :title="item.name">{{
        item.name.length > 3 ? item.name.slice(0, 2) + '...' : item.name}}</span></a-checkbox>
    </a-checkbox-group>

    <section class="btns">
      <a-button type="primary" @click="reset">重置</a-button>
      <section class="btns-r">
        <a-button type="primary" @click="close">取消</a-button>
        <a-button type="primary" class="r" @click="submit">确定</a-button>
      </section>
    </section>
  </section>
</template>

<script setup>
import { defineProps, toRefs, ref, defineEmits, defineExpose, } from 'vue';

const props = defineProps({
  list: {
    type: Array,
    default: [],
  },
  visible: {
    type: Boolean,
    default: false,
  },
});
const { list, visible, } = toRefs(props);

// emit
const emit = defineEmits(['close', 'submit',]);

const selectValue = ref([]);

const reset = () => {
  selectValue.value = [];
};

const close = () => {
  emit('close');
};

const submit = () => {
  emit('submit', selectValue.value.length ? selectValue.value.join(',') : null);
};

defineExpose({
  reset,
});

</script>

<style lang="scss">
.mineral-type-com {
  top: 0.58rem;
  left: 0rem;
  width: 4.80rem;
  // height: 3rem;
  position: absolute;

  padding: 0.13rem;
  background-image: url(~@/static/images/projectlibrary/toolbar/bg_bigger_icon.png);
  background-size: 100% 100%;
  z-index: 10;

  .ant-checkbox-group {
    display: flex;
    flex-wrap: wrap;

    .ant-checkbox-wrapper {
      width: 20%;
      margin-left: 0;
      font-size: .18rem;
      color: #fff;
    }
  }

  .btns {
    display: flex;
    justify-content: space-between;
    margin-top: 0.1rem;

    .ant-btn {
      padding: 0rem .13rem;
      height: 0.3rem;

      span {
        line-height: 0;
      }
    }

    .btns-r {
      .r {
        margin-left: 0.1rem;
        color: rgb(42, 2, 188);
      }
    }
  }
}
</style>